module.exports = __webpack_public_path__ + "static/media/bicycle.bf6461c6.png";